import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import workflowRunSourceTranscriptionLaunched, {
	type WorkflowRunSourceTranscriptionLaunchedAction,
} from '@Application/WorkflowRuns/Sources/Actions/workflowRunSourceTranscriptionLaunched';
import workflowRunSourceTranscriptionLaunchFailed, {
	type WorkflowRunSourceTranscriptionLaunchFailedAction,
} from '@Application/WorkflowRuns/Sources/Actions/workflowRunSourceTranscriptionLaunchFailed';
import type LaunchWorkflowRunSourceTranscription from '@Application/WorkflowRuns/Sources/Commands/LaunchWorkflowRunSourceTranscription';
import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import { post } from '@Domain/Api';
import fetchInterviews from '@Application/Beneficiaries/Interviews/fetchInterviews';
import FetchInterviews from '@Application/Beneficiaries/Interviews/Queries/FetchInterviews';
import type { InterviewsFetchedAction } from '@Application/Beneficiaries/Interviews/Actions/interviewsFetched';
import type { InterviewsFetchFailedAction } from '@Application/Beneficiaries/Interviews/Actions/interviewsFetchFailed';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions =
	| WorkflowRunSourceTranscriptionLaunchedAction
	| WorkflowRunSourceTranscriptionLaunchFailedAction
	| InterviewsFetchedAction
	| InterviewsFetchFailedAction;

/** The run lacks the interviews' processing state, so they are refetched; a failure is ignored. */
export default (command: LaunchWorkflowRunSourceTranscription) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<WorkflowRunPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/workflow-runs/${command.runId}/sources/${command.sourceId}/transcriptions`,
				{},
			);

			const action = workflowRunSourceTranscriptionLaunched(
				payload,
				command.facilityId,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			await fetchInterviews(new FetchInterviews(command.facilityId, command.subject))(dispatch).catch(
				() => undefined,
			);

			return action;
		} catch (error) {
			const action = workflowRunSourceTranscriptionLaunchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
